import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { PdtCateModel } from '@app/models/shoppingmall/pdt-cate.model';
import { getPdtCates, PdtCateState } from '@app/selectors/shoppingmall/pdt-cate.selector';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ProductState } from '@app/selectors/shoppingmall/product.selector';
import { setCateCd } from '@app/actions/shoppingmall/product.action';
import { ValidationUtil } from '@app/common/util/validation.util';


@Component({
    selector: 'shopping-home',
    templateUrl: './shopping-home.component.html',
    styleUrls: ['./shopping-home.component.css']
})
export class ShoppingHomeComponent implements OnInit, OnDestroy {

    pdtCates$ = new Observable<PdtCateModel[]>();
    cates: PdtCateModel[] = [];

    cate: string = "";
    cateName: string = "";

    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _overlayLoadingStore: Store<OverlayLoadingState>,
        private _pdtCateStore: Store<PdtCateState>,
        private _productStore: Store<ProductState>) {
        this.pdtCates$ = this._pdtCateStore.select(getPdtCates);
    }

    ngOnInit(): void {
        this._activatedRoute.paramMap.subscribe(params => {
            this.cate = ConvertUtil.convertToString(params.get("cate"));
            this._productStore.dispatch(setCateCd({ cateCd: this.cate }));
        });

        this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));

        this.pdtCates$.subscribe(res => {
            this.cates = res;
            let cateFilter = res.filter(v => v.cateCd === this.cate)[0];
            if(ValidationUtil.isNotNullAndNotEmpty(cateFilter)) {
                this.cateName = ConvertUtil.convertToString(res.filter(v => v.cateCd === this.cate)[0].cateName || "");
            }

            this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
        });

    }

    ngOnDestroy(): void {
        this.cate = "";
    }


    onClickCategory(item: PdtCateModel) {
        this.cateName = ConvertUtil.convertToString(item.cateName);
        this._router.navigateByUrl("/shopping-mall/cate/" + item.cateCd);
    }
}
